module.exports = __webpack_public_path__ + "static/media/buy_customer_support_3.38ee60cc.png";